export const SUPER_ADMIN = "3";
export const ADMIN = "2";
export const USER = "*";